import { SelectTestCardLoadingIndicator } from "./SelectTestLoadingIndicator";

function TestAccordingLoadingIndicator({ padding }: { padding?: string }) {
  return (
    <div className={`pb-4 ${padding}`}>
      <div>
        <div className="w-full bg-dropDownBorder animate-pulse p-2 rounded-sm mb-2" />
        <div className="flex ">
          <SelectTestCardLoadingIndicator />
          <SelectTestCardLoadingIndicator />
          <SelectTestCardLoadingIndicator />
        </div>
      </div>
      <div>
        <div className="w-full bg-dropDownBorder animate-pulse p-2 rounded-sm my-4" />
        <div className="flex ">
          <SelectTestCardLoadingIndicator />
        </div>
      </div>
      <div>
        <div className="w-full bg-dropDownBorder animate-pulse p-2 rounded-sm my-3" />
        <div className="flex ">
          <SelectTestCardLoadingIndicator />
          <SelectTestCardLoadingIndicator />
        </div>
      </div>
    </div>
  );
}

export default TestAccordingLoadingIndicator;
